import { useQuery } from "@tanstack/react-query";
import { KBULL_TOKEN_ADDRESS } from "@/config/buy";

const API = process.env.REACT_APP_BACKEND_URL;
if (!API) throw new Error("Missing REACT_APP_BACKEND_URL");

export const useMarketChart = (interval) => useQuery({
  queryKey: ["market-ohlcv", KBULL_TOKEN_ADDRESS, interval],
  queryFn: async ({ signal }) => {
    const response = await fetch(`${API}/api/market/ohlcv?interval=${encodeURIComponent(interval)}`, { signal });
    if (!response.ok) throw new Error("Chart source unavailable");
    const data = await response.json();
    // Refuse mismatched server configuration rather than charting a different token.
    if (data.mint !== KBULL_TOKEN_ADDRESS || data.interval !== interval || data.currency !== "USD") throw new Error("Chart token mismatch");
    return data;
  },
  staleTime: 120_000,
  refetchInterval: 120_000,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: false,
  retry: false,
});